import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
// Copyright 1999-2019. Plesk International GmbH. All rights reserved.
import React from 'react';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

/**
 * `Spinner` component.
 */
var Spinner = function Spinner(_ref) {
  var _ref$baseClassName = _ref.baseClassName,
      baseClassName = _ref$baseClassName === void 0 ? "".concat(CLS_PREFIX, "spinner") : _ref$baseClassName,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["baseClassName", "className"]);

  return React.createElement("svg", _extends({
    className: classNames(baseClassName, className)
  }, props, {
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("circle", {
    className: "".concat(baseClassName, "__path"),
    fill: "none",
    strokeWidth: "6",
    strokeLinecap: "round",
    cx: "24",
    cy: "24",
    r: "21"
  }));
};

export default Spinner;